import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';


// Static hosts may fall back to the app index for directory URLs.
// Open the documentation before bootstrapping session-dependent services.
if (window.location.pathname === '/docs' || window.location.pathname === '/docs/') {
  window.location.replace(`/docs/index.html${window.location.search}${window.location.hash}`);
} else {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
